import { useTranslation } from 'react-i18next'
import { Switch } from 'react-router'

import { Helmet } from 'react-helmet-async'
import AuthenticatedView from '@/authenticated-view'

// Components
import StandloneView from './components/StandaloneView'
import StandaloneTrustScoreList from './components/ApplicationList'
import Form from './components/Form'

const TrustScore = ({ history }: any) => {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>{t('l.standalone_trustscore.list.title', 'Trust Score')}</title>
      </Helmet>

      <Switch>
        <AuthenticatedView
          exact
          path="/trust-score/view/:trustScoreId"
          render={(props: any) => <StandloneView history={history} {...props} />}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/trust-score/:formType"
          component={Form}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          exact
          path="/trust-score/edit/:trustScoreId/:formType"
          component={Form}
          allowTo={['landlord']}
        />
        <AuthenticatedView
          path="/trust-score"
          render={(props: any) => <StandaloneTrustScoreList history={history} {...props} />}
          allowTo={['landlord']}
        />
      </Switch>
    </>
  )
}

export default TrustScore
